import React from 'react';
import { dateInLastDays } from '@src/services/leaderboard';
import BackButton from './BackButton';
import Title from './Title';
import { StyledHeaderContainer, StyledHeaderContent } from '../index.style';
import PreviousEventButton from './PreviousEventButton';
import PeriodSwitcher from './PeriodSwitcher';
import Tabs from './Tabs';

const Header = ({
  eventShow,
  previousEvent,
  activeTab,
  handleChangeTab,
  isLoading,
  onPreviousEvent,
  onResetEvent,
  commingSoon,
  displayDurationDays,
  maxPublishDaysBeforeEvent,
}) => (
  <StyledHeaderContainer>
    <div style={{ width: '118px' }}>
      <BackButton
        isPreviousEvent={eventShow?.id === previousEvent?.id}
        onResetEvent={onResetEvent}
      />
    </div>

    <StyledHeaderContent>
      <Title
        isPreviousEvent={previousEvent && eventShow?.id === previousEvent?.id}
        isLoading={isLoading}
      />
      <PeriodSwitcher
        isLoading={isLoading}
        endDate={eventShow?.endDate}
        startDate={eventShow?.startDate}
        commingSoon={commingSoon}
      />
      <Tabs
        maxPublishDaysBeforeEvent={maxPublishDaysBeforeEvent}
        activeTab={activeTab}
        handleChangeTab={handleChangeTab}
      />
    </StyledHeaderContent>
    {previousEvent?.id !== eventShow?.id &&
    dateInLastDays(previousEvent?.endDate, displayDurationDays) ? (
      <PreviousEventButton onPreviousEvent={onPreviousEvent} />
    ) : (
      <div style={{ width: '118px' }} />
    )}
  </StyledHeaderContainer>
);

export default Header;
